import { render, staticRenderFns } from "./gender-edit.vue?vue&type=template&id=ce5c376a&scoped=true"
import script from "./gender-edit.vue?vue&type=script&lang=js"
export * from "./gender-edit.vue?vue&type=script&lang=js"
import style0 from "./gender-edit.vue?vue&type=style&index=0&id=ce5c376a&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ce5c376a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/Resourced/Resourced/Frontend-old/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ce5c376a')) {
      api.createRecord('ce5c376a', component.options)
    } else {
      api.reload('ce5c376a', component.options)
    }
    module.hot.accept("./gender-edit.vue?vue&type=template&id=ce5c376a&scoped=true", function () {
      api.rerender('ce5c376a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "public/pages/supplier/edit-poppers/gender-edit.vue"
export default component.exports